import { inject, Pipe, type PipeTransform } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';

/**
 * Marks a manual section's HTML as trusted. This is the ONE place in the application where
 * `bypassSecurityTrustHtml` is allowed.
 *
 * WHY it is safe: the HTML is sanitized once at build time by the manual compiler and reaches the
 * browser only through the backend manual operations. WHY it is needed: Angular's sanitizer would
 * strip `playsinline` from the process videos, and iOS would then open them full screen.
 */
@Pipe({ name: 'auManualHtml' })
export class ManualHtmlPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(html: string): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
